module.exports = ".fa-size{\n    font-size: x-large !important;\n    margin-right: 10px !important;\n    color: #57ab0d;\n}\n.mar25{\n    margin-left: 25px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/package-category/package-category.component.css
// module id = ./src/app/package-category/package-category.component.css
// module chunks = main